import React, { useState } from "react";

const faqs = [
  {
    q: "What is AmmoPantryAI?",
    a: "AmmoPantryAI is a complete preparedness inventory app for iOS. Snap a photo of anything you own — ammo, firearms, reloading components, water, or medical supplies — and it identifies and logs it instantly. No manual entry required.",
  },
  {
    q: "How does photo scanning work?",
    a: "Point your camera at an ammo box, firearm, or supply item and AmmoPantryAI identifies it automatically — caliber, brand, quantity, and more. You can review and adjust the result before saving. It works for a wide range of calibers, brands, and inventory types.",
  },
  {
    q: "Is my data private?",
    a: "Your data never leaves your device. No account, no cloud, no server we maintain — nothing that can be hacked, subpoenaed, or shared without your knowledge. We built it this way on purpose. What you own is your business, not ours.",
  },
  {
    q: "What can I track beyond ammo?",
    a: "AmmoPantryAI tracks your full preparedness inventory: ammo (by caliber and brand), firearms (with serial numbers and maintenance records), reloading components (powder, primers, brass, dies), stored water, and medical supplies with expiration tracking.",
  },
  {
    q: "Where is AmmoPantryAI available?",
    a: "AmmoPantryAI is available now on iOS and Android — download it free from the App Store or Google Play.",
  },
  {
    q: "Is there a cost to use it?",
    a: "AmmoPantryAI is free to download and use. Some advanced features are available through an optional subscription. You can start tracking your inventory immediately with no commitment.",
  },
];

const FAQSection: React.FC = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section className="w-full bg-[#000000] px-4 py-24">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-16">
        {/* Left */}
        <div className="flex-1 flex flex-col items-start justify-start max-w-sm">
          <p className="text-xs font-bold uppercase tracking-widest text-[#3b82f6] mb-3">FAQ</p>
          <h2 className="text-4xl font-extrabold mb-4 text-white">Frequently Asked Questions</h2>
          <p className="text-lg text-[#a3a3a3] mb-8">
            Discover answers to your most pressing questions about AmmoPantryAI and its functionalities.
          </p>
          <a
            href="mailto:ammopantry@gmail.com"
            className="px-6 py-3 border border-white/20 rounded-md text-base font-semibold text-white hover:border-[#3b82f6] hover:text-[#3b82f6] transition inline-block"
          >
            Contact Us
          </a>
        </div>
        {/* Right: Accordion */}
        <div className="flex-1 flex flex-col gap-2">
          {faqs.map((faq, idx) => (
            <div key={faq.q} className="border-t border-white/10 pt-6">
              <button
                className="w-full relative text-left focus:outline-none pr-10 min-h-[48px]"
                onClick={() => setOpenIdx(idx === openIdx ? -1 : idx)}
                aria-expanded={openIdx === idx}
              >
                <span className="font-bold text-lg leading-snug text-white block">{faq.q}</span>
                <span className={`absolute right-0 top-1/2 -translate-y-1/2 text-2xl transform transition-transform duration-200 text-[#3b82f6] ${openIdx === idx ? 'rotate-180' : ''}`}>&#8964;</span>
              </button>
              {openIdx === idx && (
                <div className="text-[#a3a3a3] mt-4 mb-2 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
